import { StyleSystemProps } from '@withjoy/joykit';

const policyContainerStyles: StyleSystemProps = {
  flexDirection: 'column',
  maxWidth: 523,
  margin: [24, 'auto'],
  paddingBottom: 193
};

const titleStyles: StyleSystemProps = {
  textAlign: 'center'
};

const dateStyles: StyleSystemProps = {
  textAlign: 'center',
  marginTop: 7
};

const paragraphsStyles: StyleSystemProps = {
  marginTop: 80
};

export const styles = {
  title: titleStyles,
  date: dateStyles,
  paragraphs: paragraphsStyles,
  policyContainer: policyContainerStyles
};
